// extracted by mini-css-extract-plugin
export default {"container":"EditItem_container__4vvlf"};